import React from "react";
import { Sliders, List, Settings } from "react-feather";
import {WebStories,Groups, Description,ReceiptLong} from '@mui/icons-material';
import async from "../Components/Async";


const Login = async(() => import("./../pages/Login"));
const ForgotPassword = async(() => import("./../pages/ForgotPassword"));
const ResetPassword = async(() => import("./../pages/ResetPassword"));
const Dashboard = async(() => import("./../pages/Dashboard"));
const Setting = async(() => import("./../pages/Settings"));
const PoliciesList = async(() => import("../pages/Policies/PoliciesList"));
const PoliciesShow = async(() => import("./../pages/Policies/PolicyShow"));
const Report = async(() => import("./../pages/report"))

const loginRoute = {
    id: "Login",
    path: "/login",
    component: Login,
    children: null
}
const forgotPasswordRoute = {
    id: "ForgotPassword",
    path: "/forgot-password",
    component: ForgotPassword,
    children: null
}

const resetPasswordRoute = {
    id: "ResetPassword",
    path: "/reset-password/:code",
    component: ResetPassword,
    children: null
}

const dashboardsRoutes = {
    id: "Dashboard",
    path: "/dashboard",
    header: "",
    icon: <Sliders />,
    containsHome: true,
    component: Dashboard
};

const settingsRoute = {
    id: "Settings",
    path: "/settings",
    icon: <Settings />,
    component: Setting
}

const policyListRoute = {
    id: "Policies",
    path: "/policies",
    icon: <Description />,
    component: PoliciesList
}
const policyShowRoute = {
    id: "Policies",
    path: "/policies/show/:id",
    component: PoliciesShow
}

const reportRoutes = {
    id: "Report",
    path: "/report",
    icon: <ReceiptLong/>,
    component: Report
}

export const dashboard = [
    dashboardsRoutes,
    settingsRoute,
    policyListRoute,
    policyShowRoute,
    reportRoutes
]
export const auth = [];

export const unAuthRoutes = [loginRoute, forgotPasswordRoute, resetPasswordRoute];

export default [
    dashboardsRoutes,
    policyListRoute,
    // reportRoutes,
    settingsRoute
];
